import React from "react";
import PropTypes from "prop-types";

import styles from "./DotSpinner.module.scss"

const DotSpinner = (props) => {
    /* done with css */
    return (
        <div className={styles["spinner-dot"]} >
            <div className={props.color } />
            <div className={props.color } />
            <div className={props.color } />
        </div>
    );
};

DotSpinner.defaultProps = {
    color: "bg-primary"
}

DotSpinner.propTypes = {
    color: PropTypes.string
};

export default DotSpinner;